import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c3c3154"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = ["data-edit", "innerHTML"]

import { withDefaults } from 'vue';

import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1199.887 1686.952">
  <g id="fengmian4" transform="translate(8.385 2.952)">
    <path d="M16352.5,5853.607V5218.5h-7.884V4711h907.365l-640.926,814.919L16352.5,5853.607Z" transform="translate(-16353 -4711)" fill="#0f0f0f"/>
    <path d="M-14924.254-10525.763h228.223l439.748-543.189h-235.172Z" transform="translate(15270 11066)" fill="var(--theme-color-1)"/>
    <path d="M15798.295,6074H15481l596-769.1v424.842L15798.295,6074Z" transform="translate(-14885.501 -4390)" fill="var(--theme-color-1)"/>
    <path d="M15742,6046h-261l261-327.574V6046Z" transform="translate(-14550.5 -4475)" fill="#0f0f0f"/>
  </g>
</svg>
`;


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cover-4',
  props: {
    useEdit: { type: Boolean },
    projectName: {},
    time: {},
    mainPageEnterpriseName: {},
    titlePosition: {},
    settleTimePosition: {},
    aspNamePosition: {},
    orderNumber: {},
    orderNumberPostion: {}
  },
  emits: ['posChange', 'valueChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { info, onPosChange, onValueChange } = useCover(emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "data-edit": _ctx.useEdit,
        key: index,
        class: _normalizeClass({ [item.className]: true }),
        innerHTML: props[item.valueKey]
      }, null, 10, _hoisted_2)), [
        [_unref(vMove), {
        pos: props[item.posKey],
        change: (left, top) => _unref(onPosChange)(item.posKey, left, top)
      }],
        [_unref(vInput), {
        value: props[item.valueKey],
        change: (value) => _unref(onValueChange)(item.valueKey, value)
      }]
      ])
    }), 128)),
    _createElementVNode("div", {
      innerHTML: svg,
      class: "svg"
    })
  ]))
}
}

})